import axios from "../utils/http";
import utils from "../utils";

const operatingPlatform = {
  getAllCompany(name) {
    return axios.post(
      "/api/listAllCompany",
      utils.postParamsArrayToJsonString({ name })
    );
  },
  listAllUser() {
    return axios.post("/api/listAllUser");
  },

  /**
   * 快速初始化公司
   */
  quickInitializeCompanyForInternalEmployee(
    name,
    shortName,
    address,
    addressDetail,
    addressGisX,
    addressGisY,
    contactPerson,
    contactPhoneNumber,
    contactEmail,
    parentId,
    adminRoleName,
    menuConfig,
    loginPassword,
    userId
  ) {
    return axios.post(
      "/api/quickInitializeCompanyForInternalEmployee",
      utils.postParamsArrayToJsonString({
        name,
        shortName,
        address,
        addressDetail,
        addressGisX,
        addressGisY,
        contactPerson,
        contactPhoneNumber,
        contactEmail,
        parentId,
        adminRoleName,
        menuConfig,
        loginPassword,
        userId,
      })
    );
  },
};

export default operatingPlatform;
